import React from "react";
import PropTypes from "prop-types";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { FormControl } from "@material-ui/core";
import useStyles from "./styles";

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 400,
      minWidth:230,
      maxWidth:230,
      position: 'relative',
      right: 0,
    },
  },
};
export const SelectInput = ({
  id,
  name,
  size,
  onChange,
  variant,
  classname,
  value,
  error,
  fullWidth,
  ammend,
  options,
  options1,
  disabled,
  selectOption,
  isPrinciple,
  isPayment,
  defaultValue,
  defaultLabledDisabled,
  ...props
}) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <FormControl
        className={error ? classes.defaultError : classes.defaultSelect}
      >
        <Select
           classes= {{
            root: disabled ? classes.disabledInput : classes.editableInput,
          }}
          fullWidth={fullWidth}
          id={id}
          name={name}
          size={size}
          onChange={onChange}
          className={classes.selectEmpty}
          value={value}
          defaultValue={defaultValue}
          MenuProps={MenuProps}
          disabled={disabled}
          error={error}
        >
          <MenuItem
            value={selectOption ? selectOption : defaultValue ? defaultValue:""}
            className={classes.menuItem}
            disabled={defaultLabledDisabled}
          >
            {selectOption ? selectOption : defaultValue ? defaultValue :"Select"}
          </MenuItem>
          {isPrinciple
            ? options &&
              options.map((item, index) => (
                <MenuItem
                  className={classes.menuItem}
                  key={index}
                  value={item.driverIndex}
                >
                  {item.name}
                </MenuItem>
              ))
            : options
            ? options.map((item, index) => (
                <MenuItem
                  className={classes.menuItem}
                  key={index}
                  value={
                    item.name
                      ? item.name
                      : item.description
                      ? item.description
                      : item.indexID
                  }
                >
                  {item.name
                    ? item.name
                    : item.description
                    ? item.description
                    : item.groupDesc}
                </MenuItem>
              ))
            : isPayment
            ? options1.map((item, index) => (
                <MenuItem
                  className={classes.menuItem}
                  key={index}
                  value={item.indexId}
                >
                  {item.paymentPlan}
                </MenuItem>
              ))
            : options1 &&
              options1.map((item, index) => (
                <MenuItem className={classes.menuItem} key={index} value={item}>
                  {item}
                </MenuItem>
              ))}
        </Select>
      </FormControl>
    </React.Fragment>
  );
};
SelectInput.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
};
